import { useEffect } from 'react'
import { EventNames } from '../../../types/misc.types'
import { RegularPlanSheetVariant } from '../../../types/mf-execution.types'
import { trackEvent } from '../../../utils/appBridge'
import { getRegularPlanSheetConfig } from '../../../utils/mf-execution/regularSheetConfig'
import BottomSheetContent from '../BottomSheetContent'
import { PrimaryButton } from '../../execution/PrimaryButton'
import { RedirectionTab } from '../../ui-components/RedirectionTab'

type ExecutionRegularPlanLearnMoreContentProps = {
  onDismiss: () => void
  ScreenName: string
  variant: RegularPlanSheetVariant
  directFundISIN: string
  directFundName: string
}

export const ExecutionRegularPlanLearnMoreContent = ({
  onDismiss,
  ScreenName,
  variant,
  directFundISIN,
  directFundName
}: ExecutionRegularPlanLearnMoreContentProps) => {
  const { heading, content } = getRegularPlanSheetConfig(variant)

  useEffect(() => {
    trackEvent({
      eventName: EventNames.BottomSheetLoad,
      payload: {
        eventId: heading,
        bottomSheetName: 'Regular plan error',
        ScreenName
      }
    })
  }, [heading, ScreenName])

  return (
    <BottomSheetContent
      bottomSheetHeadingTestLocator='BS_TITLE'
      heading={heading}
      bottomSheetHeadingClassName='!font-[500] !leading-[130%]'
      onDismiss={onDismiss}
      bottomSheetCtas={
        <PrimaryButton
          testLocator='BS_CTA_PRIMARY'
          label='Close'
          onClick={onDismiss}
          primaryButtonClassName='!h-[56px]'
        />
      }
    >
      <div>
        <span test-locator='BS_DESC' className='text-[#6A6E6E] leading-[150%] text-[14px] font-[400]'>
          {content}
        </span>
      </div>

      {variant === RegularPlanSheetVariant.INVEST && (
        <div className='pt-4'>
          <RedirectionTab isPage={false} directFundISIN={directFundISIN} directFundName={directFundName} title='Invest in Direct Plan' />
        </div>
      )}
    </BottomSheetContent>
  )
}
